import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent, SelectionSettingsModel, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { ColumnChangeBO, columnWidth } from '../../lov/lov.model';
import { authpermission, CallBo, ClientBO, clientFilter, EditDetailsClient, Exportmonitorlist, functionpermission, GetClientEmployeeRelationshipBO, GetListBase, QPfilter } from '../client-parent.model';
import { ClientHttpService } from '../client-parent.service';
import { clienttserivce } from '../clienttservice';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { onboardingservice } from '../../onboarding/onboarding.service';
import { CommonApiService } from 'src/app/commonapiservice';
import { EmitMonitorList } from '../../client-monitorlist/client-monitorlist.model';
import { Router } from "@angular/router";
import { log } from 'console';
import { EDI271BO } from "../../eligibility270/eligibility270.model";
import { deletepermission } from '../../timesheet/timesheet.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ClientTabBO } from '../../consultation-services/consultation-services.modal';
@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss']
})
export class ClientListComponent implements OnInit {
  @Input() DataFromList: EditDetailsClient = new EditDetailsClient();
  @Output() EventToEdit = new EventEmitter<EditDetailsClient>();
  @ViewChild('grid') public grid: GridComponent;
  ClientStatus: [{ Key: string, Value: string }]
  ColumnArray: columnWidth[]
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  EditOptions: EditDetailsClient = new EditDetailsClient();
  filterOptions1: FilterSettingsModel;
  filterOptions: FilterSettingsModel;
  initialPage: object;
  username: any;
  id: string = "00000000-0000-0000-0000-000000000000";
  getClient: GetListBase = new GetListBase();
  clientFilter = new clientFilter();
  private onDestroy$: Subject<void> = new Subject<void>();
  getClientListerr: any = ""
  isDatashowfilter: boolean = false;
  public filterSettings: object;
  public formatOptions1: object;
  public formatOptions: object;
  public wrapSettings: TextWrapSettingsModel;
  public data: Observable<DataStateChangeEventArgs>;
  QpStatusDropdown: [{ Key: number, Value: string }]
  ClientDropDown: [{ Key: string, Value: string }]
  arraycol: any = [];
  dropdata: string[] = []
  QPFilter: QPfilter = new QPfilter();
  saveClientEmployee: any = new GetClientEmployeeRelationshipBO();
  locationId: string = "00000000-0000-0000-0000-000000000000";
  filterstatuslid: any;
  statusList: any = []
  fp: authpermission = new authpermission();
  ISEDI271Client: boolean = false;
  ISEDI271ClientDiffReport: boolean = false;
  viewFiles271: boolean = false;
  edi271list: EDI271BO[] = [];
  ClientId: any;
  EmployeeDropdown: any=[];
  authDropdown:any =[];
  isAuthorizationReport: boolean = false;
  selectedProfile: any[] = [];
  isCompleted : boolean = true;
  documentDetails : any;
  errDetails : any;
  profilestatus : any[] = [{'Key':'Completed','Value':true},{'Key':'Incomplete','Value':false}];
  isEnabled: boolean = false;
  languageList : any[];
  DeleteClientId : string="00000000-0000-0000-0000-000000000000";
  deleteError: any = []
  deleteList: deletepermission = new deletepermission();
  passerror: boolean = false;
  resetPass: FormGroup;
  isClickButton:boolean=false;
  saveErr: string = "";
  callbo : CallBo = new CallBo(); 
   public selectionOptions: SelectionSettingsModel;
  exportmonitorlistbo : Exportmonitorlist = new Exportmonitorlist();
  ClientListTotalColumns:number=26;
  Consultationform: ClientTabBO = new ClientTabBO();

  constructor(public http: ClientHttpService, 
    public router: Router,
    public datepipe: DatePipe, public global: GlobalComponent, @Inject(clienttserivce) public clienttserivce: clienttserivce,
     public toastrService: ToastrService,
     public CommonAPI:CommonApiService,
     private cdr: ChangeDetectorRef,
    public httpService: onboardingservice) {
    this.global.checkforlogout();

    this.data = clienttserivce;
    this.resetPass = new FormGroup({
      Password: new FormControl("", [Validators.required]),
    });
  }
  ngOnInit(): void {
    this.clearGridLocalStorage();
    localStorage.removeItem('gridClientListgrid');
  if (this.global.globalAgencyId == null ||
    this.global.globalAgencyId == undefined ||
    this.global.globalAgencyId == "" ||
    this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
    return;
  }
  
  if (this.global.selectedLocationDropdown == null || 
      this.global.selectedLocationDropdown == undefined || 
      this.global.selectedLocationDropdown == '') {
    this.locationId = null;
  }
  else {
    this.locationId = this.global.selectedLocationDropdown;
  }
  
  this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
  this.wrapSettings = { wrapMode: 'Content' };
  this.filterOptions = { type: 'Excel' };
  this.filterSettings = { type: 'Menu' };
  this.formatOptions1 = { type: 'date', format: 'MM/dd/yyyy HH:mm:ss' };
  this.filterOptions1 = { type: 'Menu' };
  
  // ✅ MODIFY THIS - Only set page settings and restore basic filters
  if (!this.DataFromList?.isclientfilterEnable) {
    // ❌ No saved filters - use defaults
    this.initialPage = { 
      pageSizes: ['10', '20', '50', '100', '250'], 
      pageSize: 10,
      currentPage: 1
    };
  } else {
    // ✅ RESTORE saved filters (basic ones only, dropdowns will restore later)
    this.getClient = { ...this.DataFromList.ClientfilterDetails }; // Deep copy
    this.initialPage = { 
      pageSizes: ['10', '20', '50', '100', '250'], 
      pageSize: this.DataFromList?.ClientfilterDetails?.pageitem || 10,
      currentPage: this.DataFromList?.ClientfilterDetails?.currentpageno || 1
    };
    
    // ✅ Restore search text (safe to do now)
    this.Searchtext = this.DataFromList?.ClientfilterDetails?.searchText;
    
    // ❌ REMOVE THIS - Don't restore selectedColor here, do it in getMonitorList()
    // this.selectedColor = ...
  }
  
  this.global.referralcontact = false;
  this.global.referralTab = false;
  
  this.selectionOptions = {
    checkboxOnly: true
  }
  
  this.getlanguage();
  this.getpermission();
  
  // ✅ These will now handle restoration internally
  this.getMonitorList();  // Will restore selectedColor
  this.getEmployeeDropdown();
  this.getYESNO();
  this.getStatus();  // Will restore statusLId and call getClientListDetails()
    setTimeout(() => {
    if (this.grid) {
      this.grid.clearFiltering();
    }
  }, 500);
}
  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "Client");
      // params.append("roleId", this.global.roleId);
      // params.append("agencyId", this.global.globalAgencyId)
      this.http.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data != null) {
          this.fp = data;

        }
        else {
          this.fp = new authpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new authpermission();
        })
    }
  }
  getclinetStatus() {
    let params = new URLSearchParams();
    this.http.getClientStatusDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: string, Value: string }]) => {

      this.ClientStatus = JSON.parse(JSON.stringify(data));
      this.QpStatusDropdown = JSON.parse(JSON.stringify(data));
      this.dropdata = data.map(e => e.Value);

      this.ClientStatus.push({ Key: "00000000-0000-0000-0000-000000000000", Value: "All" });

      this.getClient.statusLId = this.ClientStatus.filter(st => st.Value == "Active")[0].Key;
      this.QPFilter.Status = this.ClientStatus.filter(st => st.Value == "Active")[0].Key;
      this.saveClientEmployee.statusLid = this.ClientStatus.filter(st => st.Value == "Active")[0].Key;
      this.getClientListDetails();
    })


    // let params = new URLSearchParams();
    // params.append("Code", "STATUS");
    // params.append("agencyId", this.global.globalAgencyId);
    // params.append("userId", this.global.userID);
    // let url = "api/LOV/getLovDropDown?"
    // this.http.getStatus(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: number, Value: string }]) => {

    //   this.ClientStatus = JSON.parse(JSON.stringify(data));
    //   /// this.QpStatusDropdown= this.ClientStatus;
    //   this.QpStatusDropdown = JSON.parse(JSON.stringify(data));
    //   this.dropdata = data.map(e => e.Value);
    //   // this.eligiblitydropdata.push("Eligible");
    //   // this.eligiblitydropdata.push("Not Eligible");

    //   this.ClientStatus.push({ Key: 0, Value: "All" });

    //   this.getClient.statusLid = this.ClientStatus.filter(st => st.Value == "Active")[0].Key;
    //   this.QPFilter.Status = this.ClientStatus.filter(st => st.Value == "Active")[0].Key;
    //   this.saveClientEmployee.statusLid = this.ClientStatus.filter(st => st.Value == "Active")[0].Key;

    //   this.getClientListDetails();
    // })

  }
  public dataChangeClient(state): void {
    let val = (state.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.getClient.orderColumn = state.sorted[0].name;
        this.getClient.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && state.action.action != "clearFilter") {
      state.action.currentFilterObject.field === "phone1"
        ? (state.action.currentFilterObject.value =
          state.action.currentFilterObject.value
            .replace(" ", "")
            .replace("(", "")
            .replace(")", "")
            .replace("-", ""))
        : state.action.currentFilterObject.value;
      // state.action.currentFilterObject.field === "phone1" ? state.action.currentFilterObject.value = state.action.currentFilterObject.value.replace(' ', "").replace('(', "").replace(')', "").replace('-', "") : state.action.currentFilterObject.value;
      if (state.action.currentFilterObject.field == "status_Name") {

        this.getClient.value = this.ClientStatus.filter(e => e.Value == state.action.currentFilterObject.value)[0].Key.toString()
        this.getClient.field = "statusLid";
        this.getClient.statusLId = this.ClientStatus.filter(e => e.Value == state.action.currentFilterObject.value)[0].Key
        this.getClient.type = "number";
        this.getClient.operator = "equal";
      }
      else if (this.getClient.type == "number") {
        this.getClient.value = state.action.currentFilterObject.value.toString();
        this.getClient.field = state.action.currentFilterObject.field;


      }
      else if (this.getClient.type == "date") {
        this.getClient.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");

        this.getClient.field = state.action.currentFilterObject.field;
      }
      else {
        this.getClient.value = state.action.currentFilterObject.value;
        this.getClient.field = state.action.currentFilterObject.field;





        this.getClient.matchCase = state.action.currentFilterObject.matchCase;
        this.getClient.operator = state.action.currentFilterObject.operator;

      }
    }
    else {
      if (val == "filtering" && state.action.action == "clearFilter") {
        this.getClient.field = "Name";
        this.getClient.matchCase = false;
        this.getClient.operator = "contains";
        this.getClient.value = "";
        this.getClient.type = "string"
        if (this.ClientStatus && this.ClientStatus.length > 0) {
          this.getClient.statusLId = this.ClientStatus[0].Key;
        }
      }
    }
    if (val == "paging" && state.action.name == "actionBegin") {
      // if (this.grid.pagerModule.pagerObj.pageSize != this.arraycol[0].Client.Pagesize) {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Client.Pagesize != state.take) {
          this.arraycol[0].Client.Pagesize = state.take
          this.SaveColumnwidth();
          // }
        }
      }
    }
    this.getClientListDetails();
  }
  //.........................................onActionClient.....................................................
  public onActionClient(cli) {
    this.getClient.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.getClient.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    if (cli.name == "actionBegin" && cli.requestType == "filterbeforeopen") {
      this.getClient.type = cli.columnType
    }
  }
  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);

    this.ColumnArray = this.arraycol[0].Client.Columns;
    let showcol = this.arraycol[0].Client.ShowColumns;
    let hidecol = this.arraycol[0].Client.HideColumns
    //   this.grid.showColumns(showcol);
    this.grid.hideColumns(hidecol);

    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }
    this.grid.pageSettings.pageSize = this.arraycol[0].Client.Pagesize;
    this.ColumnArray.forEach(element => {

      if (element.column == 'Name') {

        const column = this.grid.getColumnByField('name'); // get the JSON object of the column corresponding to the field name
        // column.headerText = element.column;
        column.width = element.width;

        this.grid.refreshHeader();
        //this.grid.refreshColumns();
      }
      if (element.column == 'Medicaid') {

        const column = this.grid.getColumnByField('medicaid'); // get the JSON object of the column corresponding to the field name
        // column.headerText = element.column;
        column.width = element.width;

        this.grid.refreshHeader();
        //this.grid.refreshColumns();
      }

      if (element.column == 'DOB') {

        const column1 = this.grid.getColumnByField('dob'); // get the JSON object of the column corresponding to the field name

        column1.width = element.width;

        this.grid.refreshHeader();
      }
      if (element.column == 'QP Name') {

        const column1 = this.grid.getColumnByField('qPname'); // get the JSON object of the column corresponding to the field name

        column1.width = element.width;

        this.grid.refreshHeader();
      }
      if (element.column == 'Primary Physician') {

        const column1 = this.grid.getColumnByField('primaryPhysician'); // get the JSON object of the column corresponding to the field name

        column1.width = element.width;

        this.grid.refreshHeader();
      }
      if (element.column == 'Age') {

        const column1 = this.grid.getColumnByField('age'); // get the JSON object of the column corresponding to the field name

        column1.width = element.width;

        this.grid.refreshHeader();
      }
      if (element.column == 'Phone') {

        const column1 = this.grid.getColumnByField('phone1'); // get the JSON object of the column corresponding to the field name

        column1.width = element.width;

        this.grid.refreshHeader();
      }
      if (element.column == 'Location') {

        const column2 = this.grid.getColumnByField('locationName'); // get the JSON object of the column corresponding to the field name
        // column2.headerText = element.column;
        column2.width = element.width;
        this.grid.refreshHeader();

      }
      if (element.column == 'Street') {

        const column1 = this.grid.getColumnByField('street'); // get the JSON object of the column corresponding to the field name

        column1.width = element.width;

        this.grid.refreshHeader();
      }
      if (element.column == 'Zip Code') {

        const column1 = this.grid.getColumnByField('zipCode'); // get the JSON object of the column corresponding to the field name

        column1.width = element.width;

        this.grid.refreshHeader();
      }
      if (element.column == 'Status') {

        const column1 = this.grid.getColumnByField('status_Name'); // get the JSON object of the column corresponding to the field name

        column1.width = element.width;

        this.grid.refreshHeader();
      }
      if (element.column == 'MN Choice Assessment Received') {

        const column1 = this.grid.getColumnByField('isMNChoiceAssessment'); // get the JSON object of the column corresponding to the field name

        column1.width = element.width;

        this.grid.refreshHeader();
      }
      if (element.column == 'lastEligibility') {

        const column1 = this.grid.getColumnByField('lastEligibility'); // get the JSON object of the column corresponding to the field name

        column1.width = element.width;

        this.grid.refreshHeader();
      }
      if (element.column == 'checkeligibility') {

        const column2 = this.grid.getColumnByUid('checkeligibility'); // get the JSON object of the column corresponding to the field name
        // column2.headerText = element.column;
        column2.width = element.width;
        this.grid.refreshHeader();

      }
      if (element.column == 'MA Eligible') {

        const column2 = this.grid.getColumnByField('isMAEligible'); // get the JSON object of the column corresponding to the field name
        // column2.headerText = element.column;
        column2.width = element.width;
        this.grid.refreshHeader();

      }
      if (element.column == 'Actions') {

        const column2 = this.grid.getColumnByUid('action'); // get the JSON object of the column corresponding to the field name
        // column2.headerText = element.column;
        column2.width = element.width;
        this.grid.refreshHeader();

      }
      if (element.column == 'Client Insurance ID') {

        const column = this.grid.getColumnByField('insuranceNo'); // get the JSON object of the column corresponding to the field name
        // column.headerText = element.column;
        column.width = element.width;

        this.grid.refreshHeader();
        //this.grid.refreshColumns();
      }
      if (element.column == 'Languages') {

        const column = this.grid.getColumnByField('languages'); // get the JSON object of the column corresponding to the field name
        // column.headerText = element.column;
        column.width = element.width;

        this.grid.refreshHeader();
        //this.grid.refreshColumns();
      }
    });
  }
  SaveColumnwidth() {
    this.arraycol[0].Client.Columns = this.ColumnArray;
    this.arraycol[0].Client.Pagesize = this.grid.pageSettings.pageSize;
    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id
    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.http.savecolumwidth(this.columnchange).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.getColumnwidth();
    });
  }
  // AddClient(modalType: string) {
  //   if (modalType == 'new') {
  //     this.EditOptions.clientData = new ClientBO();
  //     this.EditOptions.isEdit = true;
  //     this.EditOptions.isclientfilterEnable = true;
  //     this.EventToEdit.emit(this.EditOptions);
  //     this.EditOptions.isnewClient = true;
  //     this.EditOptions.newclient = true
  //   }
  //   else {
  //     this.EditOptions.newclient = false
  //     this.EditOptions.isnewClient = false;
  //     this.EditOptions.isEdit = true;
  //     this.EditOptions.isEditClient = true;
  //     this.EditOptions.isclientfilterEnable = true;
  //     this.EventToEdit.emit(this.EditOptions);
  //   }
  //   this.global.docbool = false;

  // }
  AddClient(modalType: string) {
  if (modalType == 'new') {
    this.EditOptions.clientData = new ClientBO();
    this.EditOptions.isEdit = true;
    this.EditOptions.isclientfilterEnable = true;  // ✅ Already exists
    this.EditOptions.ClientfilterDetails = this.getClient;  // ✅ ADD THIS - Save current filters!
    this.EditOptions.isnewClient = true;
    this.EditOptions.newclient = true;
    this.EventToEdit.emit(this.EditOptions);
  }
  else {
    this.EditOptions.newclient = false;
    this.EditOptions.isnewClient = false;
    this.EditOptions.isEdit = true;
    this.EditOptions.isEditClient = true;
    this.EditOptions.isclientfilterEnable = true;  // ✅ Already exists
    this.EditOptions.ClientfilterDetails = this.getClient;  // ✅ ADD THIS - Save current filters!
    this.EventToEdit.emit(this.EditOptions);
  }
  this.global.docbool = false;
}
  show() {
    this.grid.columnChooserModule.openColumnChooser(500, 50); // give X and Y axis
  }
  //=================================Clientdatatobind====================//
  // Clientdatatobind(data: any) {
  //   this.EditOptions.clientId = data.id
  //   this.global.clientId = data.id;
  //   this.EditOptions.clientData = data;
  //   this.EditOptions.clientData.dOB = data.dob
  // }
  Clientdatatobind(data: any) {
  this.EditOptions.clientId = data.id;
  this.global.clientId = data.id;
  this.EditOptions.clientData = data;
  this.EditOptions.clientData.dOB = data.dob;
  
 
  this.EditOptions.ClientfilterDetails = this.getClient;
  this.Consultationform.ClientId = this.global.clientId;

}
  Searchtext: string = "";
  getClientListDetails() {
    this.getClient.locationID = this.locationId;
    //this.getClient.searchColumn="Name";
    
    if (this.global.isClientNewTab == true) {
      this.getClient.clientID =  this.global.EventClientid;
      // this.Searchtext = this.global.searchClientText;
      this.getClient.searchText = this.Searchtext;
      this.getClient.statusLId = this.ClientStatus?.filter(
        (st) => st.Value == this.global.searchClientStatus
      )[0]?.Key;
       
    }
   
   
    this.getClient.value = this.global.CxCustomerName != null && this.global.CxCustomerName != undefined && this.global.CxCustomerName != '' ? this.global.CxCustomerName : this.getClient.value;
    this.clienttserivce.execute(this.getClient);
    let val = 0
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {    
      if ((data != null && data.result.length > 0)) {
        this.isDatashowfilter = true;
      }
      else {
        this.isDatashowfilter = false;
      }
      val++;
      if (data != null && data != undefined && val == 1) {
        // this.getColumnwidth();
        if (data.result.length > 15) {
          this.grid.height = '500';
        }
        else {

          this.grid.height = 'auto';
        }
      }
      if (this.global.CxCustomerName != null && this.global.CxCustomerName != undefined && this.global.CxCustomerName != '') {
        if (data.result.length > 0) {
          data.result?.forEach((data) => {
            this.AddClient(data);
            this.Clientdatatobind(data);
          });
        }
      }

      if (this.global.isClientNewTab == true) {
        if (data.result.length > 0) {
          data.result?.forEach((data) => {
            this.AddClient(data);
            this.Clientdatatobind(data);
            localStorage.removeItem("cfss_ClientNewTabFunctionality");
            this.global.isClientNewTab = false;
          });
        }
      } else {
        localStorage.removeItem("cfss_ClientNewTabFunctionality");
        this.global.isClientNewTab = false;
      }
    })
  }
  getStatus() {
  let params = new URLSearchParams();
  params.append("listCode", "STATUS");
  
  this.http.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
    this.statusList = data;
    
    let values = {
      "id": null,
      "lovName": "ALL",
      "lovCode": "ALL",
      "lovValue": "ALL"
    }
    this.statusList.push(values);
   
    if (this.DataFromList?.isclientfilterEnable && 
        this.DataFromList?.ClientfilterDetails?.statusLId) {
      this.getClient.statusLId = this.DataFromList.ClientfilterDetails.statusLId;
    } else {
      this.getClient.statusLId = this.statusList?.filter(s => s.lovName == "Active")[0]?.id;
    }
    
    this.getClientListDetails();
  })
}
  // Refresh() {
  //   this.getClient.monitorId= "00000000-0000-0000-0000-000000000000";
  //   this.getClient.employeeID="00000000-0000-0000-0000-000000000000";
  //   this.getClient.authStatus=null;
  //   this.getClient.isCompleted=null;
  //   this.selectedColor = [];
  //   this.getClient.value='';
  //   this.getClient.languageLIds =[];
  //   this.getClientListDetails();
  //   //this.getStatus();
  //   //this.getEmployeeDropdown();
  // }
  Refresh() {
  this.getClient.monitorId = "00000000-0000-0000-0000-000000000000";
  this.getClient.employeeID = "00000000-0000-0000-0000-000000000000";
  this.getClient.authStatus = null;
  this.getClient.isCompleted = null;
  this.getClient.searchText = "";  
  this.getClient.currentpageno = 1;  
  this.selectedColor = [];
  this.getClient.value = '';
  this.getClient.languageLIds = [];
 this.getClient.statusLId = this.statusList?.filter(s => s.lovName == "Active")[0]?.id;
  
  this.EditOptions.isclientfilterEnable = false;
  this.EditOptions.ClientfilterDetails = null;
  //this.getStatus();
  this.getClientListDetails();
  this.grid.clearFiltering();
}
  exportCsv() {

    this.http.getExportCsv().pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      let contentType = 'text/csv';
      const blob = this.b64toBlob(data.fileContents, contentType);
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = "Client Export";

      a.click();
      // FileSaver.saveAs(data,"Client Export");
    })



  }
  b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {

    const byteCharacters = atob(b64Data);

    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {

      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {

        byteNumbers[i] = slice.charCodeAt(i);

      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);

    }

    const blob = new Blob(byteArrays, { type: contentType });

    return blob;

  }
  changeClientPortalPass() {
    if (this.username == null || this.username == undefined || this.username == '') {
      this.toastrService.error("This client does not have a portal credential account.", 'Error'), 8000;
      return;
    }
    let params = new URLSearchParams();

    params.append("type", "client");
    params.append("Email", this.username);
    if (this.global.agencyCode == "SUPERADMIN") {
      params.append("AgencyCode", this.global.selectAgencyCode);
    } else {
      params.append("AgencyCode", this.global.agencyCode);
    }
    this.httpService.forgotPasswordclient(params).subscribe((data: any) => {
      if (data) {
        this.toastrService.success('Temporary password has been sent to your respective mail id',
          'Temporary password sent successfully'), 8000;
      }
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }
  resetpassword(data) {
    this.username = data.userName;
  }

  colors = [
    { label: 'Red', value: 'red' },

    { label: 'Yellow', value: 'yellow' },
    { label: 'Green', value: 'green' },
    { label: 'Blue', value: 'blue' }
  ];

  selectedColor: any;


  monitorfilter()
  {console.log(this.selectedColor,"this.selectedColo");
    
    if(this.selectedColor == undefined || this.selectedColor =="" || this.selectedColor ==null)
    {
      this.getClient.monitorId =null;

    }else{
      this.getClient.monitorId = this.monitorList.filter(m=> m.colorName== this.selectedColor)[0]?.monitorId;

    }
  console.log(this.getClient.monitorId,"monitorid=============")
    this.getClientListDetails();
  }
  monitorNotes:any;
  Getdata(data)
  {
    this.monitorNotes= data.monitorNote
  }
  monitorList:any=[]
  // getMonitorList() {
  //   let myparams = new URLSearchParams();
  // //  myparams.append("clientId", this.global.clientId.toString());
  //   let url = "api/Client/GetMonitors?";
  //   this.CommonAPI.GetFunctionwithResponseTypeJson(myparams, url).subscribe(
  //     (data) => { 
  //          this.monitorList = data;
  //          this.monitorList.forEach(element => {
  //           element.label = element.colorName
  //           element.value = element.colorName
  //           element.colorandnotes = element.colorandnotes
  //          });
  //         //  colors = [
  //         //   { label: 'Red', value: 'red' },
        
  //         //   { label: 'Yellow', value: 'yellow' },
  //         //   { label: 'Green', value: 'green' },
  //         //   { label: 'Blue', value: 'blue' }
  //         // ];
  //   })
  // }
getMonitorList() {
  let myparams = new URLSearchParams();
  let url = "api/Client/GetMonitors?";
  this.CommonAPI.GetFunctionwithResponseTypeJson(myparams, url).subscribe(
    (data) => { 
      this.monitorList = data;
      this.monitorList.forEach(element => {
        element.label = element.colorName;
        element.value = element.colorName;
        element.colorandnotes = element.colorandnotes;
      });
      
      // ✅ ADD THIS - Restore monitor color AFTER list is loaded
      if (this.DataFromList?.isclientfilterEnable && 
          this.DataFromList?.ClientfilterDetails?.monitorId) {
        const savedMonitor = this.monitorList.find(
          m => m.monitorId === this.DataFromList.ClientfilterDetails.monitorId
        );
        if (savedMonitor) {
          this.selectedColor = savedMonitor.colorName;
          this.getClient.monitorId = savedMonitor.monitorId;
        }
      }
    })
}
  EmitMonitorList: EmitMonitorList = new EmitMonitorList()
  //.......................................viewClientMonitorList.................................
  viewClientMonitorList(id) {
    this.EmitMonitorList.isClient = true
    this.EmitMonitorList.clientId = id
    this.EmitMonitorList.employeeId = null;
    this.EmitMonitorList.isView = true;
    document.getElementById("Viewemitmonitormodal1").click();
  }
    //.......................................closeviewModal.................................
    closeviewModal() {
      this.EmitMonitorList = new EmitMonitorList()
      document.getElementById("Viewemitmonitormodal1").click();
    }
    //.......................................closeEligiblity.................................
  closeEligiblity() {
    this.ISEDI271Client = false;
    document.getElementById("EligibilityOpen").click();
  }
  //.......................................closeEligiblityDifference.................................
  closeEligiblityDifference() {
    this.ISEDI271ClientDiffReport = false;
    document.getElementById("EligibilitydiffOpen").click();
  }
  //.......................................print.................................
  print() {
    this.grid.print();
  }
  //.......................................validatebutton.................................
  validatebutton(args) {
    if (args.column.field == "checkeligibility") {
      if (
        args.data["lastEligibility"] == null ||
        args.data["lastEligibility"] == ""
      ) {
        args.cell.children[0].classList.add("disableedit");
        args.cell.children[1].classList.add("disableedit");
      }
    }
  }
  //.......................................showReport.................................
  // showReport() {
  //   this.reportcontain = true;
  //   this.reptitle = "Client Labels";
  //   if (this.getClient.type == "datetime") {
  //     var startDate =
  //       this.getClient.value != null &&
  //         this.getClient.value != undefined &&
  //         this.getClient.value != ""
  //         ? this.global.getDateTimeString(this.getClient.value) : ""
  //   }
  //   this.CommonAPI.CommonFunctionforPowerBiToken().then((token) => {
  //     document.getElementById("openPowerBiReport").click();
  //     let embedUrl = "";
  //     let embedReportId = "";
  //     embedUrl =
  //       "https://app.powerbi.com/rdlEmbed?reportId=" +
  //       this.configuration.ClientLabels +
  //       "&rp:AgencyId=" +
  //       this.global.globalAgencyId +
  //       "&rp:UserId=" +
  //       this.global.userID +
  //       "&rp:field=" +
  //       (this.getClient.value == ""
  //         ? "Name"
  //         : this.getClient.field.toString()) +
  //       "&rp:val=" +
  //       (this.getClient.type == "datetime"
  //         ? startDate
  //         : this.getClient.value.toString()) +
  //       "&rp:Operator=" +
  //       this.getClient.operator +
  //       "&rp:condition=" +
  //       " where upper(" +
  //       '"' +
  //       "name" +
  //       '"' +
  //       ") ~ " +
  //       "'" +
  //       this.getClient.searchText.toUpperCase() +
  //       "'" +
  //       "&rp:LocationId=" +
  //       (this.global.globalLocationId == null || undefined
  //         ? 0
  //         : this.global.globalLocationId) +
  //       "&rp:StatusLid=" +
  //       (this.getClient.statusLid == null || undefined
  //         ? 1
  //         : this.getClient.statusLid) +
  //       "&filterPaneEnabled=False&rdl:reportView=pageView&rdl:parameterPanel=hidden";
  //     embedReportId = this.configuration.ClientLabels;
  //     let config = {
  //       type: "report",
  //       tokenType: pbi.models.TokenType.Aad,
  //       accessToken: token[0],
  //       embedUrl: embedUrl,
  //       id: embedReportId,
  //       settings: {},
  //       viewmode: pbi.models.ViewMode.View,
  //     };
  //     let reportContainer = this.reportContainer.nativeElement;
  //     let powerbi = new pbi.service.Service(
  //       pbi.factories.hpmFactory,
  //       pbi.factories.wpmpFactory,
  //       pbi.factories.routerFactory
  //     );
  //     let report = powerbi.embed(reportContainer, config);
  //     report.off("loaded");
  //     report.on("loaded", () => { });
  //   });
  // }
  //.......................................viewlasteb.................................
  viewlasteb(id) {
    let myparams = new URLSearchParams();
    myparams.append("id", id);
    let url = "api/ClaimProcess/GetClients271Detail?";
    this.CommonAPI
      .GetFunctionwithResponseTypeJson(myparams, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.edi271list = data;
          this.viewFiles271 = true;
          document.getElementById("openModal7").click();
        },
        (err: HttpErrorResponse) => {
          this.toastrService.error(err.message, "error");
        }
      );
  }
  //.......................................EligibilityClose.................................
  EligibilityClose() {
    document.getElementById("EligibilityOpen").click();
  }
  //.......................................vieweligibilitydiff.................................
  vieweligibilitydiff(id) {
    this.ClientId = id;
  }
    
    //......................................getEmployeeDropDown.........................................................
  // getEmployeeDropdown() {
  //   let myParams = new URLSearchParams();
  //   // myParams.append("LocationId", this.locationId.toString());
  //   let url = "api/Employee/employeeDropDown?";
  //   this.CommonAPI
  //     .GetFunctionwithResponseTypeJson(myParams, url)
  //     .pipe(takeUntil(this.onDestroy$))
  //     .subscribe((data: any) => {
  //       data.unshift({
  //       "Key": "00000000-0000-0000-0000-000000000001",
  //       "Value": "No Assigned Employee"
  //       })
  //       this.EmployeeDropdown = data;
  //     });
  // }
  getEmployeeDropdown() {
  let myParams = new URLSearchParams();
  let url = "api/Employee/employeeDropDown?";
  this.CommonAPI
    .GetFunctionwithResponseTypeJson(myParams, url)
    .pipe(takeUntil(this.onDestroy$))
    .subscribe((data: any) => {
      data.unshift({
        "Key": "00000000-0000-0000-0000-000000000001",
        "Value": "No Assigned Employee"
      });
      this.EmployeeDropdown = data;
      
      // ✅ ADD THIS - Restore employee filter
      if (this.DataFromList?.isclientfilterEnable && 
          this.DataFromList?.ClientfilterDetails?.employeeID) {
        this.getClient.employeeID = this.DataFromList.ClientfilterDetails.employeeID;
      }
    });
}
  //.......................................filterchange.................................
  filterchange() {
    this.getClient.employeeID =(this.getClient.employeeID!=null)? (this.getClient.employeeID.toString()):"00000000-0000-0000-0000-000000000000";
    this.getClientListDetails();
  }

    

    //.......................................report.................................
  report() {
    this.router.navigateByUrl("/client-reports");
  }
  getYESNO() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "YESORNO");
    this.CommonAPI.getDropDownList("YESORNO", params, url, "LovDropDown").then((data: any) => {
      this.authDropdown = data;
      this.authDropdown.forEach(element => {
        element.Value = element.lovName;
        element.Key = element.id.toString();
      })
    })
  }
  openMissingDocumentsModal(data: any) {
    console.log(data)   
    this.documentDetails = data.error; 
    this.errDetails = data.error;
    document.getElementById("missingDocumentsModalTrigger").click();
  }
  ///........................................SelectErrorData....................................................
  SelectErrorData() {

    if (this.isEnabled == true) {
      this.documentDetails = this.documentDetails.filter(err => err.isValid == false);
    }
    else {
      this.documentDetails = this.errDetails;
    }
  }

  getlanguage() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "Language");
    this.CommonAPI.getDropDownList("Language", params, url, "LovDropDown").then(
      (data: any) => {
        this.languageList = data;
      },
      (err) => { this.toastrService.error(err); }
    );
  }
  

   //.......................................selectemployeedetails.................................
   selectemployeedetails(data) {
    this.DeleteClientId = data.id
    this.getClientdeleteError();
  }
    //.......................................getClientdeleteError.................................
    getClientdeleteError() {
      this.deleteError = []
      let params = new URLSearchParams();
      params.append("Id", this.DeleteClientId?.toString());
      let url = "api/Client/CheckClientToDelete?"
      this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (data?.length != 0) {
          this.deleteError = data
          document.getElementById('openDeleteErrorModal').click();
        } else {
          this.deleteList = new deletepermission();
          this.passerror = false;
          this.resetPass.reset();
          document.getElementById('openClientDeleteModal').click();
          this.deleteError = []
        }
      },
        (err: HttpErrorResponse) => {
  
          this.toastrService.error(err.error, "error");
        })
    }
     //..............................................CancelDelete.....................
  CancelDelete() {
    document.getElementById('openClientDeleteModal').click();
    this.deleteList = new deletepermission();
    this.passerror = false;
    this.resetPass.reset();
  }
    //.......................................passWordValidation.....................
    passvalid(event) {
      let str = event.target.value;
      if (
        str.match(/[a-z]/g) &&
        str.match(/[A-Z]/g) &&
        str.match(/[0-9]/g) &&
        str.match(/[^a-zA-Z\d]/g) &&
        str.length >= 8
      ) {
        this.passerror = false;
      } else {
        this.passerror = true;
      }
    }

      //.......................................deleteClient.................................
  deleteClient() {
    this.isClickButton=true
    let params = new URLSearchParams();
    params.append("Password", this.deleteList.admin_Password);
    params.append("Id", this.DeleteClientId);
    let url = "api/Client/ClientDelete?"
    this.http.Deleteclient(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success('Client deleted successfully!');
      this.isClickButton=false
      this.getClientListDetails()
      document.getElementById('openClientDeleteModal').click();
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
      this.passerror = false;

    },

      (err: any) => {
        this.isClickButton=false
        this.passerror = false;
        this.saveErr = err;
        setTimeout(() => {
          this.saveErr = "";
        }, 8000);

      })
  }
  selectedClientIds: string[] = []; // to store selected client IDs

// This method will be triggered when row selection changes
onRowSelected(args: any) {
  const selectedRecords = this.grid.getSelectedRecords();
  this.selectedClientIds = selectedRecords.map((record: any) => record.id); // assuming `id` is the identifier
}

  makeCall(){
    this.callbo.clientIds = this.selectedClientIds;
    this.callbo.eventConfirmation = true;
    let url = "api/Client/EnableEventConfirmationForClients";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.callbo , url).pipe(takeUntil(this.onDestroy$)).subscribe((data : any)=>{
    this.grid.clearSelection();
    this.selectedClientIds = [];
    this.getClientListDetails();
    },
  (err : any)=>{
    console.log(err);
    this.toastrService.error(err);
     

  })
  }
  exportmonitorlist(){
    this.exportmonitorlistbo.monitorId =  this.getClient.monitorId;
    this.exportmonitorlistbo.clientIds = this.selectedClientIds;
    this.exportmonitorlistbo.LanguageLIds = this.getClient.languageLIds;
    this.exportmonitorlistbo.SearchText = this.getClient.searchText;
    this.exportmonitorlistbo.SearchColumn = this.getClient.searchColumn;
    this.exportmonitorlistbo.EmployeeId = this.getClient.employeeID;
    this.exportmonitorlistbo.AuthStatus = this.getClient.authStatus;
    this.exportmonitorlistbo.isCompleted = this.getClient.isCompleted;
    this.exportmonitorlistbo.StatusLId = this.getClient.statusLId;
    let url="api/Client/ExportClientDetailsCsv";
    this.CommonAPI.saveorUpdateFunctionFileSaver(this.exportmonitorlistbo, url, "clientmonitorlist.csv");

  }
  closeauthreport(){
    document.getElementById('AuthReportopen').click();
    this.isAuthorizationReport = false;
  }

  clearGridLocalStorage(): void {
    // Define grid configurations for visits
    const gridConfigs = [
      { localStorageKey: 'gridClientListgrid', expectedColumns: this.ClientListTotalColumns },
    ];
    
    // Use global method for localStorage clearing
    this.global.clearGridIdLocalStorage(gridConfigs);
  }
}



